import { render, staticRenderFns } from "./MomentCreateGoodsRemarkPage.vue?vue&type=template&id=25e5d390&scoped=true&"
import script from "./MomentCreateGoodsRemarkPage.vue?vue&type=script&lang=js&"
export * from "./MomentCreateGoodsRemarkPage.vue?vue&type=script&lang=js&"
import style0 from "./MomentCreateGoodsRemarkPage.vue?vue&type=style&index=0&id=25e5d390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5d390",
  null
  
)

export default component.exports